export default __webpack_public_path__ + "static/media/philo3.b419b9c6.png";